exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{margin:0;padding:0}a{text-decoration:none}body,html{height:100%}a,a:active,a:hover,a:link,a:visited{display:block;width:100%;height:100%;color:#475669}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/modules/normalize.css
// module id = 653
// module chunks = 0